import React from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";

export default function MyMap({ lat, lng }) {
    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY
        , // replace with your key
    });

    const center = { lat: lat, lng: lng };

    if (!isLoaded) {
        return <p>Loading map...</p>;
    }

    return (
        <GoogleMap
            mapContainerStyle={{ width: "100%", height: "500px" }}
            center={center}
            zoom={15}
        >
            <Marker position={center} />
        </GoogleMap>
    );
}
